module.exports = __webpack_public_path__ + "static/img/ent-detail-59.094be45.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-detail-59.jpg
// module id = 2VXo
// module chunks = 52